module.exports = __webpack_public_path__ + "img/cliente07.c467684d.jpg";